import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["variant", "as", "children", "ramp", "className", "weight"];
import React, { forwardRef } from 'react';
import makeClass from 'clsx';
import { useTheme } from '@design-systems/theme';
import { variantMap } from './Typography.types';
import styles from './Typography.css';

/**
 * Typography
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
const Typography = /*#__PURE__*/forwardRef(function (_ref, ref) {
  let _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'body-1' : _ref$variant,
    as = _ref.as,
    children = _ref.children,
    ramp = _ref.ramp,
    propsClassName = _ref.className,
    weight = _ref.weight,
    rest = _objectWithoutProperties(_ref, _excluded);
  // Set element default based on variant
  const Component = as || variantMap[variant];

  // Styling
  let parsedWeight;
  if (typeof weight === 'number') {
    parsedWeight = `fw-${weight}`;
  }
  const parsedScreenSize = `ramp-${ramp}`;
  const _useTheme = useTheme({}, styles),
    themeClass = _useTheme.themeClass;
  const classNames = makeClass(propsClassName, themeClass, styles[variant], ramp && styles[parsedScreenSize], weight && styles[parsedWeight || weight]);

  // Final render
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    className: classNames
  }, rest), children);
});
export default Typography;
//# sourceMappingURL=Typography.js.map